import React, { useState } from 'react';

import { Plus, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

import Picker from './Picker';

type Props =
  | {
      nullable: true;
      label: string;
      onChange: (value: string | null) => void;
      defaultValue: string | null;
    }
  | {
      nullable: false;
      label: string;
      onChange: (value: string) => void;
      defaultValue: string;
    };
export default function ColorInput({ label, defaultValue, onChange, nullable }: Props) {
  const [value, setValue] = useState(defaultValue);
  const [open, setOpen] = useState(false);

  const renderResetButton = () => {
    if (!nullable) {
      return null;
    }
    if (typeof value !== 'string' || value.trim().length === 0) {
      return null;
    }
    return (
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={() => {
          setValue(null);
          onChange(null);
        }}
      >
        <X className="h-4 w-4 text-muted-foreground" />
      </Button>
    );
  };

  const renderOpenButton = () => {
    if (value) {
      return (
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8 p-0"
          style={{ backgroundColor: value }}
        />
      );
    }
    return (
      <Button variant="outline" size="icon" className="h-8 w-8">
        <Plus className="h-4 w-4" />
      </Button>
    );
  };

  return (
    <div className="flex flex-col items-start">
      <Label className="mb-0.5">{label}</Label>
      <div className="flex flex-row gap-1">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            {renderOpenButton()}
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Picker
              value={value || ''}
              onChange={(v) => {
                setValue(v);
                onChange(v);
              }}
            />
          </PopoverContent>
        </Popover>
        {renderResetButton()}
      </div>
    </div>
  );
}
